import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function ArticleNavbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-background-50'
      }`}
    >
      <div className="flex items-center justify-between h-[70px] px-6 md:px-10 max-w-[1280px] mx-auto">
        <Link to="/" className="flex flex-col">
          <span className="text-foreground-900 font-heading text-lg font-semibold tracking-tight leading-tight">
            gtbuyspreadsheet
          </span>
          <span className="text-foreground-500 text-[11px] tracking-widest uppercase">
            Verified Hub
          </span>
        </Link>

        <div className="flex items-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-foreground-700 text-sm font-medium hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-4-line"></i>
            Home
          </Link>
          <Link
            to="/spreadsheet-beginners-guide"
            className="hidden md:inline-flex items-center gap-1.5 text-foreground-600 text-sm hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-shopping-bag-line"></i>
            Shopping Guide
          </Link>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-4 py-2 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Main Store
            <i className="ri-external-link-line text-xs"></i>
          </a>
        </div>
      </div>
    </nav>
  );
}